export default {
  getMealDetails: 'GET_MEAL_DETAILS',
  getMealDetailsSuccess: 'GET_MEAL_DETAILS_SUCCESS',
  getMealDetailsFailed: 'GET_MEAL_DETAILS_FAILED',
};
